var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-drawer',{attrs:{"title":_vm.title,"visible":_vm.showDrawer,"with-header":true,"before-close":_vm.handleClose,"size":_vm.drawerWidth},on:{"update:visible":function($event){_vm.showDrawer=$event}}},[_c(_vm.drawerContent,{tag:"component",on:{"closeDrawer":_vm.handleClose}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }